module.exports = __webpack_public_path__ + "static/media/Tick_Tock_Stock_Thumbnail.1fc23aa0.png";